import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { moduleName } from '../../moduleInfo';
import {
  getSetupInvoicesRoute,
  setupInvoicesRoute,
} from '../../utils/apiRoutes';

export const setupInvoicesAsync = createAsyncThunk(
  `${moduleName}/setupInvoices`,
  async (payload) => {
    console.log('payload api', { ...payload });
    const response = await axios({
      method: 'PUT',
      url: setupInvoicesRoute(),
      data: { ...payload },
    });
    const data = response.data;
    return data;
  }
);

export const getSetupInvoicesAsync = createAsyncThunk(
  `${moduleName}/getSetupInvoices`,
  async (payload) => {
    const { schoolId } = payload;
    console.log('school id payload', { schoolId });
    const response = await axios({
      method: 'GET',
      url: getSetupInvoicesRoute(),
      params: {
        schoolId,
      },
    });
    // console.log('response', response.data);
    const data = response.data;
    return data;
  }
);

const setupInvoicesSlice = createSlice({
  name: `${moduleName}/setupInvoices`,
  initialState: {
    loading: false,
    setupInvoicesFormData: [],
    setupInvoicesDetails: [],
    getSetupInvoicesDetails: [],
    error: '',
  },
  reducers: {
    setupInvoicesFormData: (state, action) => {
      state.setupInvoicesFormData = action.payload;
    },
  },
  extraReducers: {
    [setupInvoicesAsync.pending]: (state) => {
      state.loading = true;
    },
    [setupInvoicesAsync.fulfilled]: (state, action) => {
      console.log('action.payload invoices', action.payload);
      state.setupInvoicesDetails = action.payload.data;
    },
    [setupInvoicesAsync.rejected]: (state) => {
      state.loading = false;
    },
    [getSetupInvoicesAsync.pending]: (state) => {
      state.loading = true;
    },
    [getSetupInvoicesAsync.fulfilled]: (state, action) => {
      state.getSetupInvoicesDetails = action.payload.data;
      //   state.getSetupInvoicesDetails = {
      //     gst: true,
      //     gstNo: '2556314',
      //     gstPercentage: 5,
      //     _id: '61543af8a981e87c24cabf68',
      //     branchId: '102532',
      //     schoolId: '614aeb3a6ccc6ad37a613f29',
      //     schoolName: 'discovery school',
      //     logo: '61540cdf7dabb15f38b5a7e6_newlogo.png',
      //     address: 'hkjfnlkasd',
      //     termsAndConditions: [
      //       {
      //         _id: '61543b30a981e87c24cabf6a',
      //         key: '1',
      //         value: 'fjklkd',
      //       },
      //       {
      //         _id: '61543b30a981e87c24cabf6b',
      //         key: '2',
      //         value: 'asdqweqwe',
      //       },
      //     ],
      //     prefix: '2021',
      //     suffix: '002',
      //   };
    },
    [getSetupInvoicesAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { setupInvoicesFormData } = setupInvoicesSlice.actions;

export default setupInvoicesSlice.reducer;
